import { type Timestamp, type TimestampDisplaySetting, RELATIVE, ABSOLUTE } from '../types';

// @ts-expect-error - TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
const getDaysElapsed = (date: Timestamp) => (Date.now() - new Date(date)) / (1000 * 60 * 60 * 24);

// In accordance with the ADG spec for date formats (https://hello.atlassian.net/wiki/spaces/ADG/pages/195123084/Date+formats+product+1.0+spec)
export const getADGTimestampDisplaySetting = (date: Timestamp): TimestampDisplaySetting =>
	getDaysElapsed(date) < 8 ? RELATIVE : ABSOLUTE;
